import React, { useRef, useEffect, useState } from 'react';
import { getWordFiles, uploadWordFile, deleteWordFile } from '../services/api';
import { FaPlus, FaTrash } from 'react-icons/fa';
import StandardTable from '../components/StandardTable';

const DocsProcessor = () => {
    const [wordFiles, setWordFiles] = useState([]);
    const [wordSheet, setWordSheet] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);


    const fetchWordFiles = async () => {
        try {
            setLoading(true);
            const res = await getWordFiles({ page, per_page: perPage, search });
            setWordFiles(res.data.map(file => ({ ...file, actions: [{ label: 'Delete', onClick: () => handleDelete(file.id) }] })));
            setTotal(res.total);
            setLoading(false);
        } catch (err) {
            setError(err.message || 'Failed to fetch Excel files');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWordFiles();
    }, [page, search, perPage]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handleFileChange = (e) => {
        setWordSheet(e.target.files[0]);
        setSuccess('');
        setError('');
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!wordSheet) {
            setError('Please select a file');
            return;
        }

        const formData = new FormData();
        formData.append('file', wordSheet);

        try {
            const res = await uploadWordFile(formData);
            if (res.status_code !== 201) {
                setError(res.message || 'Upload failed');
                return;
            } else {
                setSuccess(res?.message || 'File uploaded successfully');
                fetchWordFiles();
            }
        } catch (err) {
            setError(err.message || 'Upload failed');
        }
        // 2. Clear input and state in both success and error cases
        setWordSheet(null);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };
    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this file?')) return;
        try {
            await deleteWordFile(id);
            fetchWordFiles();
        } catch (err) {
            setError(err.message);
        }
    };

    const columns = [
        { name: 'ID', selector: row => row.id, sortable: true, width: '80px' },
        { name: 'Filename', selector: row => row.filename, sortable: true },
        { name: 'Uploaded By', selector: row => row.uploaded_by, sortable: true },
        { name: 'Uploaded At', selector: row => row.uploaded_at, sortable: true },
        {
            name: 'Actions',
        },
    ];

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleRowsPerPageChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setPage(page);
    };

    return (
        <div className="mt-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Docs Template</h2>
                <button className="btn btn-primary" style={{ backgroundColor: '#5865F2' }} onClick={() => {
                    setShowModal(true);
                    setError('');
                    setSuccess('');
                }}>
                   <FaPlus/> Upload New File
                </button>
            </div>
            <StandardTable
                columns={columns}
                data={wordFiles}
                search={search}
                onSearchChange={(e) => setSearch(e.target.value)}
                loading={loading}
                paginationServer={true}
                paginationTotalRows={total}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleRowsPerPageChange}
            />
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <form onSubmit={handleUpload}>
                                <div className="modal-header">
                                    <h5 className="modal-title">Upload Word File</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    {success && <div className="alert alert-success">{success}</div>}
                                    {error && <div className="alert alert-danger">{error}</div>}
                                    <div className="mb-3">
                                        <label>Select Word File</label>
                                        <input
                                            type="file"
                                            accept=".docx, .doc"
                                            className="form-control"
                                            ref={inputRef}
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-success">Upload</button>
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DocsProcessor;